module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-002"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-002-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-002-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("L")]), _vm._v("iz opened all")]), _vm._v(" the cards and stood them on her window sill, deciding not to take them home but to keep them at work on display for a week, before putting them away. Three were from people she didn’t know, and she felt a pang as she realised how much she had missed during her nine months "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("absence")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She sorted out her desk. It soon became clear, in anticipation of her return, Tom and Oliver had been filling her drawer with files requiring her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("attention")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She took them out to prioritise. All seven cases were new to her, and she spent the best part of her first day back reading through paperwork. She fired emails off as and when they were required, and she stayed at her desk through her lunch break, grateful for the sandwich Karen brought "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("in")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She only rang Sadie twice. The first time was to discover Jake was happy, playing with his toys and crawling everywhere, and the second time she was told he was asleep, worn out by the excitement of the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("morning")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She felt momentarily disgruntled. He could, at least, have made a pretence of missing her, playing up, and testing his childminder. Did he have to be at his most pleasant "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("best")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She was surprised to see that it was almost five, and she closed her computer and locked away the paper files. She was saying good night to Karen when she heard her phone ringing in the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("distance")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You didn’t put that through to me?’ she asked. ‘Stupid question, wasn’t it? I’m standing "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("here")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Karen shook her head. ‘No, I didn’t. It’ll be an internal call. Go home, Mrs Chambers. Whoever it was, they’ll try again "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("tomorrow")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thank you, Karen, good "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("night")]), _vm._v(".’")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("L")]), _vm._v("iz had forgotten")]), _vm._v(" how steep the climb back up to the tram stop was, and she sank gratefully into a seat for the long journey home. She exited the tram one stop further than her home one, walked across the road and up a hill to collect "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Jake")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sadie smiled as she let Liz into her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("home")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘He’s been absolutely fine, and he’s all ready to go.’ She picked him up from the play pen, and fastened him into his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("pushchair")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yours now,’ she said with a laugh. ‘Two stinky nappy changes, today, so you’re welcome to the little monkey. I’ll see you in the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("morning")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thanks, Sadie. You’ve made this return to work really easy for me, but I’m glad I’m only doing three days a week until Jake’s in "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("school")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sadie helped Liz lift the pushchair out of the door, and Liz felt once more at peace. Jake was back with her, and all was right again in her world. So far, she hadn’t been able to fault Sadie. On the days that she cared for Jake, she didn’t have other children, and Liz appreciated this fact. It meant that Jake benefited from one-to-one care all the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("time")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz laughed as Sadie pushed back her purple hair. ‘What colour will it be next week?’ she "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("asked")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m fancying bright red,’ Sadie answered, ‘but we’ll see, we’ll "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("see")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz walked down the hill, and reached her own front door five minutes later. She unlocked it and instantly heard Daniel’s music playing in his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("bedroom")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m home,’ she called, and she heard a muffled ‘"), _c('i', [_vm._v("hi, Mum’")]), _vm._v(" as she bent over to release the pushchair straps holding Jake "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("prisoner")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("G")]), _vm._v("areth followed")]), _vm._v(" her half an hour later. She was sitting on the sofa, Jake bathed, dressed in his sleepsuit and sleeping with his head on her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("shoulder")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I wanted five minutes,’ she said. ‘I’ll take him up "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("now")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Gareth leaned across and kissed his son on his head, bypassing his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("wife")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Everything okay?’ he "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("asked")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She nodded. ‘It’s been fine. Give me a couple of minutes to put him in his cot, and we’ll "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("talk")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Gareth walked into the kitchen to see Daniel taking a lasagne out of the oven. ‘Smells delicious, Dan.’ Gareth ruffled his son’s hair as he went "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("past")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Of "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("course")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘With "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("chips")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sorry, it’s salad. Mum’s banned "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("chips")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Your fault, Dad. She says you’re putting on far too much weight, so we’re all having to "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("suffer")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Gareth’s face spoke of misery. ‘Has she included wine in this ban, or can I have a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("glass")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘“When you’ve lost a stone” were her precise "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("words")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Water it is then.’ The misery had extended to his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("voice")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He set the table, and Liz joined them a couple of minutes "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("later")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Son number two asleep. Let’s hope he stays that "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("way")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She sat down, and waited for Gareth and Dan to join "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("her")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Looks lovely, "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Dan")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dan placed the lasagne in the centre of the table and took out the salad bowl from the fridge. He added a dish of coleslaw, a jug of lemon water, and they all sat down. ‘Vin de citron,’ he announced, and his father glared at "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Not even vaguely funny, "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Dan")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Dad, eat your "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("salad")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz and Dan looked at each other and tried to hide the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("laughter")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The quicker you lose that stone, the better,’ Dan said, finally giving in and grinning at his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("dad")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But it’s winter. Nobody eats salad in "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("winter")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You are,’ Liz "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("said")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re cruel,’ Gareth grumbled, heaping another pile of coleslaw onto his salad to try and give it some taste. ‘What’s wrong with meat and potato "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("pie")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nothing. You want that tomorrow?’ Dan asked. ‘We’ve got enough meat in the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("freezer")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dan had taken on the role of head chef in the household. He intended going to catering college after leaving school, and Gareth and Liz were only too happy to let him feed them; he had taken over the day-to-day shopping in the early weeks following Jake’s birth – and the cooking, much to their "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("delight")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So,’ Gareth said to his wife, ‘how was "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("today")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes, good,’ she said. ‘There’s at least three new employees I don’t know yet, I’ve had lots of welcome back cards, and Tom and Oliver bought me a huge bouquet of roses. And a coffee machine. They also filled up my drawer with files all requiring urgent "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("attention")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘And did they get urgent "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("attention")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Of course. All filed back into their proper places, I’ve emailed Tom and Oliver and told them what I’ve done, and I’ll bet my drawer has another half a dozen tomorrow. I think they’ve missed me. They’ve asked me not to have any more babies,’ she added with a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("smile")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I echo that,’ Gareth said drily. Liz said nothing; over the past three or four years there had been a gulf between them, one that seemed to be permanent since Jake’s birth. Deep down, she knew she was keeping the family together for the stability this offered to Dan at a crucial exam-ridden stage of his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("life")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They finished off their meal with fat-free yoghurts poured over banana slices as a concession to the new regime imposed on Gareth, and Dan switched on the coffee machine while he loaded the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("dishwasher")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s good to have a slave, isn’t it?’ Gareth remarked thoughtfully, and Liz nodded in "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("agreement")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dan shook his head, and switched on the dishwasher. ‘I am not,’ he said slowly and carefully, ‘emptying it. Do it before you go to bed, please. Right, I’m done. Coffee’s ready whenever you want it, and I’m going up on the computer. Behave yourselves, no arguing, and no more "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("babies")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Gareth and Liz burst out "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("laughing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thank you, sweetheart. The meal was delicious, and I’ll do breakfast,’ Liz said with a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("smile")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Mom. We eat "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("cornflakes")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll get the box out. And the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("dishes")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He shook his head and walked out of the kitchen. "), _c('i', [_vm._v("Parents, ")]), _vm._v("he thought. "), _c('i', [_vm._v("Why do we have to have "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("them")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He switched on his computer, checked all three screens were functioning as per his instructions, and settled down to work on the game he was "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("creating")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019cea2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-002.vue
// module id = 87
// module chunks = 0